<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-24 10:24:27
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\CustomForm\CustomFormRecord\CustomFormRecord.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-28 16:44:56
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_CustomFormRecord_list_title')"
    pad="0"
  >
    <template v-slot:page-main>
      <Taber
        contentBackground="transparent"
        special
        :curTab="curTab"
        @change="(tab) => (curTab = tab)"
        :items="taber"
      >
        <template v-slot:content-1>
          <Tabler
            :headers="headers"
            :height="$vuetify.breakpoint.height - 335"
            :items="desserts1"
            :showSelect="showSelect"
            :totalCount="totalCount1"
            @change="
              (page, perpage, callback) => {
                getList(1, page, perpage, callback);
              }
            "
          >
            <template v-slot:item.name="{ item }">
              <div
                class="table-title text--primary"
                :title="$getCommonLangValue(item.application_type_name)"
              >
                {{ $getCommonLangValue(item.application_type_name) }}
              </div>
            </template>
            <template v-slot:item.swift_number="{ item }">
              <div
                class="table-title text--primary"
                :title="$getCommonLangValue(item.swift_number)"
              >
                {{ $getCommonLangValue(item.swift_number) }}
              </div>
            </template>
            <template v-slot:item.submitDate="{ item }">
              <div class="table-title text--primary">
                {{ $getDateTime(item.submission_utc_datetime, "YYYY/MM/DD") }}
              </div>
              <div class="table-subtitle text--secondary">
                {{ $getDateTime(item.submission_utc_datetime, "HH:mm") }}
              </div>
            </template>
            <template v-slot:item.status="{ item }">
              <StatusChip
                :slideColor="item.approval_tint_color"
                :bgColor="item.approval_bg_color"
              >
                <template v-slot:status>
                  {{ $getCommonLangValue(item.status_detail) }}
                </template>
              </StatusChip>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                @click="toView(item.uuid, item.data_type)"
                v-if="hasBtn('view-admin-custom-form-record')"
              >
                <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
              </v-btn>
            </template>
          </Tabler>
        </template>
        <template v-slot:content-2>
          <Tabler
            :headers="headers"
            :items="desserts2"
            :height="$vuetify.breakpoint.height - 335"
            :showSelect="showSelect"
            :totalCount="totalCount2"
            @change="
              (page, perpage, callback) => {
                getList(2, page, perpage, callback);
              }
            "
          >
            <template v-slot:item.name="{ item }">
              <div
                class="table-title text--primary"
                :title="$getCommonLangValue(item.application_type_name)"
              >
                {{ $getCommonLangValue(item.application_type_name) }}
              </div>
            </template>
            <template v-slot:item.swift_number="{ item }">
              <div
                class="table-title text--primary"
                :title="$getCommonLangValue(item.swift_number)"
              >
                {{ $getCommonLangValue(item.swift_number) }}
              </div>
            </template>
            <template v-slot:item.submitDate="{ item }">
              <div class="table-title text--primary">
                {{ $getDateTime(item.submission_utc_datetime, "YYYY/MM/DD") }}
              </div>
              <div class="table-subtitle text--secondary">
                {{ $getDateTime(item.submission_utc_datetime, "HH:mm") }}
              </div>
            </template>
            <template v-slot:item.status="{ item }">
              <StatusChip
                :slideColor="item.approval_tint_color"
                :bgColor="item.approval_bg_color"
              >
                <template v-slot:status>
                  {{ $getCommonLangValue(item.status_detail) }}
                </template>
              </StatusChip>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                @click="toView(item.uuid, item.data_type)"
                v-if="hasBtn('view-admin-custom-form-record')"
              >
                <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
              </v-btn>
            </template>
          </Tabler>
        </template>
      </Taber>
    </template>
    <template v-slot:tools-main> </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "CustomFormRecord",
  components: {},
  computed: {},
  data() {
    return {
      taber: [
        "label_essweb_CustomFormRecord_list_tab_underReviewLabel",
        "label_essweb_CustomFormRecord_list_tab_completeLabel",
      ],
      curTab: "tab-1",
      totalCount1: 0,
      totalCount2: 0,
      showSelect: false,
      headers: [
        {
          text: "label_essweb_CustomFormRecord_list_FormNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_CustomFormRecord_list_swiftNumberLabel",
          value: "swift_number",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_CustomFormRecord_list_submitDateLabel",
          value: "submitDate",
          align: "start",
          sortable: true,
          sort: (prop, desc, calback) => {
            return this.$sortList(
              this.curTab == "tab-1" ? this.desserts1 : this.desserts2,
              "submission_utc_datetime",
              desc ? true : false,
              "datetime"
            ).then((res) => {
              calback(desc);
              this.curTab == "tab-1"
                ? (this.desserts1 = res)
                : (this.desserts2 = res);
            });
          },
        },
        {
          text: "label_essweb_customForm_list_customFormStatusLabel",
          value: "status",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts1: [],
      desserts2: [],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(1, 1, this.$tableSetting.perPageSize, null);
    this.getList(2, 1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    toView: function (uuid, data_type) {
      this.$toPage(
        "/admin/custom-form-record/detail/" +
          this.$aesEncrypt(
            JSON.stringify({
              id: uuid,
              data_type: data_type,
            })
          )
      );
    },
    getList: function (flow_status, page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_application_record",
        url: "/application/get-application-list/",
        data: {
          flow_status: flow_status,
          cpage: page,
          pagesize: perpage,
        },
      }).then((res) => {
        if (flow_status == 1) {
          that.desserts1 = res.data ? res.data : [];
          that.totalCount1 = res.totalcount;
          callback ? callback() : null;
        }
        if (flow_status == 2) {
          that.desserts2 = res.data ? res.data : [];
          that.totalCount2 = res.totalcount;
          callback ? callback() : null;
        }
      });
    },
  },
};
</script>
